import { AnalyticsBrowser } from '@segment/analytics-next'
import { env, app } from 'config'

export const analytics = new AnalyticsBrowser()

if (app.analyticsEnabled) {
  analytics.load({ writeKey: env.REACT_APP_SEGMENT_API_KEY })
}
